export default __webpack_public_path__ + "static/media/130.6b20cbac.png";